/**
 * Access-control definitions for the umi `access` plugin.
 *
 * Every key becomes a boolean readable through `useAccess()` and usable as the
 * `access` field of a route in `config/routes.ts`. Only the admin role is
 * modelled today; the app's real gate is the session check in `src/app.tsx`.
 *
 * @see https://umijs.org/docs/max/access
 */
export default function access(initialState: { currentUser?: DATA.UserDefine } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.role === 'admin',
  };
}
